const TRADEMARK_FIELD = 'marcaConfiguracao'

// Valor sentinela da opção "Sem marca" — não colide com nome real de marca.
export const SEM_MARCA = '__SEM_MARCA__'
export const SEM_MARCA_LABEL = 'Sem marca'

export function rotuloMarca(trademark) {
    return trademark === SEM_MARCA ? SEM_MARCA_LABEL : trademark
}

/**
 * Cria o predicado de filtro por marca usado nos hooks de KPI.
 *
 * Item sem a propriedade `marcaConfiguracao` é sempre mantido (KPI que não
 * carrega marca). Item com marca vazia/nula só é mantido quando a opção
 * "Sem marca" (SEM_MARCA) está entre as selecionadas.
 *
 * @param {Array} selectedTrademarks Marcas selecionadas no filtro.
 * @returns {Function} Predicado que decide se o item permanece na lista.
 */
export function criarFiltroMarca(selectedTrademarks) {
    const selectedSet = new Set(selectedTrademarks)

    return function (item) {
        if (!Object.hasOwn(item, TRADEMARK_FIELD)) {
            return true
        }

        const marca = item[TRADEMARK_FIELD]

        if (!marca) {
            return selectedSet.has(SEM_MARCA)
        }

        return selectedSet.has(marca)
    }
}
